// =============================================================================
// SITE CONFIGURATION — Le Comptoir du Marché (Montrouge)
// =============================================================================
// Master configuration for Le Comptoir du Marché bistro, market counter
// and live music tavern.
// Controls styling, localization, reservations, SEO, and integrations.
// =============================================================================

import type { SiteConfig } from '@webzite/content-schema';

const siteConfig: SiteConfig = {
  // =========================================================================
  // VISUAL STYLE
  // =========================================================================
  // Le Comptoir du Marché style pack — Montrouge market counter with
  // cement tile blue, garden green, sunburst orange, honey guitar wood,
  // and interactive guitar string oscillation animations.
  stylePack: 'comptoir-du-marche',

  // =========================================================================
  // GEOGRAPHIC REGION
  // =========================================================================
  // European Union — EU-14 allergen regulations, GDPR cookie consent.
  region: 'eu',

  // =========================================================================
  // LANGUAGE & LOCALIZATION
  // =========================================================================
  defaultLocale: 'fr',
  locales: ['fr', 'en', 'zh', 'de', 'it', 'pt'],
  currency: 'EUR',

  // =========================================================================
  // RESERVATIONS
  // =========================================================================
  reservations: {
    enabled: true,
    provider: 'custom',
    bookingUrl: 'tel:+33973617181',
  },

  // =========================================================================
  // DELIVERY PLATFORMS
  // =========================================================================
  delivery: {
    enabled: false,
    platforms: [],
  },

  // =========================================================================
  // MAP
  // =========================================================================
  maps: {
    provider: 'osm',
    embedUrl:
      'https://www.openstreetmap.org/export/embed.html?bbox=2.3140,48.8120,2.3240,48.8170&layer=mapnik&marker=48.814741,2.3193216',
    googleMapsLink:
      'https://www.google.com/maps/place/COMPTOIR+DU+MARCHE/@48.814741,2.3193216,17z/data=!4m17!1m10!3m9!1s0x47e671003ae24c79:0x4bbe20982643c44!2sCOMPTOIR+DU+MARCHE!8m2!3d48.814741!4d2.3193216!10e5!14m1!1BCgIgAQ!16s%2Fg%2F11ddwtkgcm!3m5!1s0x47e671003ae24c79:0x4bbe20982643c44!8m2!3d48.814741!4d2.3193216!16s%2Fg%2F11ddwtkgcm!5m1!1e2?entry=ttu&g_ep=EgoyMDI2MDkwMi4wIKXMDSoASAFQAw%3D%3D',
    appleMapsLink:
      'https://maps.apple.com/?q=Comptoir+du+Marche+11+bis+Avenue+Verdier+92120+Montrouge',
  },

  // =========================================================================
  // ANALYTICS
  // =========================================================================
  analytics: {
    cloudflare: { enabled: true },
    ga4: {
      enabled: false,
      measurementId: '',
    },
  },

  // =========================================================================
  // SEO (Search Engine Optimization)
  // =========================================================================
  seo: {
    titleTemplate:
      '%s | Le Comptoir du Marché — Bistrot, Cuisine du Marché & Musique Live · Montrouge',
    defaultDescription:
      'Bistrot chaleureux au 11 bis Av. Verdier, Montrouge. Cuisine du marché fraîche, couscous artisanal, concerts acoustiques, terrasse et bonne humeur.',
    ogImage: '/images/og-image.png',
  },

  // =========================================================================
  // DEVELOPER ATTRIBUTION & WATERMARK
  // =========================================================================
  developer: {
    name: 'jeduapf',
    url: 'https://portfolio.jeduapf.com',
    role: 'Restaurant Web Developer',
    showFooterCredit: true,
  },

  // =========================================================================
  // ALLERGEN REGULATION
  // =========================================================================
  allergenRegulation: 'eu-fic-1169',
};

export default siteConfig;
